/**
 * Checks if something is a string.
 * @param {Object|String} obj.
 * @returns {Boolean} Is string.
 */
function isAString(obj) {
  // Boolean. Answers the Q of is your thing a string or not
  return obj.constructor === String ? true : false;
}

/**
 * Uppercases the first character of a string.
 * @param {String}.
 * @returns {String} An uppercased first character of a string.
 */
function upperCaseFirst(str) {
  // 'blah blah bity' -> 'Blah blah bity'
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Lowercases all characters except for the first.
 * @param {String} str.
 * @returns {String} A lowercased string with no whitespace.
 */
function lowerCaseAllButFirst(str) {
  // 'LOTS OF TEXT' -> 'Lots of text'
  return str.charAt(0) + str.slice(1).toLowerCase();
}

/**
 * Lowercases all characters and removes all whitespace.
 * @param {String}.
 * @returns {String} A lowercased string with no whitespace.
 */
function lowerTrimString(str) {
  // e.g. ' Blah Blah YAda' -> 'blahblahyada'
  return str.replace(/ /g, '').toLowerCase();
}

/**
 * Checks if a value is in a string.
 * @param {String} val
 * @param {String} str.
 * @returns {Boolean} Is value in string.
 */
function isValueInString(values, str) {
  return str.indexOf(values) !== -1;
}

/**
 * Checks if all values are in a string.
 * @param {String} str
 * @param {String} values.
 * @returns {Boolean} Are all values in string.
 */
function stringHasAllValues(str) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  return values.every(function (value) {
    return isValueInString(value, str);
  });
}

/**
 * Checks if a string has an DOM ID.
 * @param {String} str.
 * @returns {Boolean} Has ID.
 */
var stringHasId = function stringHasId(str) {
  return str.match(/^#([0-9A-Za-z_-]+)/) || false;
}; // '#someId' -> true, '#/someString' -> false

/**
 * Checks if a string contains a DOM attribute.
 * @param {String} str.
 * @returns {Boolean} Has attribute.
 */
var stringHasAttr = function stringHasAttr(str) {
  return str.match(/^\[([0-9A-Za-z-])+=([\"0-9A-Za-z-])+\"]/) || false;
}; // '[attr="stuff"]' -> true

/**
 * Checks if a string contains a DOM class.
 * @param {String} str.
 * @returns {Boolean} Has class.
 */
var stringHasClass = function stringHasClass(str) {
  return str.match(/^\.([0-9A-Za-z_-]+)/) || false;
}; // '.someClass' -> true, './someClass' -> false

/**
 * Converts a string to camel-case.
 * Known issue when trying to convert all cap str. "TEST STRING" => "TEST STRING"
 * @param {String} str.
 * @returns {String} A camel-cased string.
 */
var toCamelCase = function toCamelCase(str) {
  return str.replace(/[-_\s]([a-z])/g, function (x, up) {
    return up.toUpperCase();
  });
}; // 'blah-yada_tah dah' -> 'blahYadaTahDah'

/**
 * Converts a string to kebab-case.
 * @param {String} str.
 * @returns {String} A kebab-cased string.
 */
var toKebabCase = function toKebabCase(str) {
  return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
    return x.toLowerCase();
  }).join('-');
};

/**
 * Converts a string to pascal-case.
 * Known issue: Not converting first word if all caps ("TEST STRING" => "TESTString") and not capitalizing single char word.("is a string" => "IsaString")
 * @param {String} str.
 * @returns {String} A pascal-cased string.
 */
var toPascalCase = function toPascalCase(str) {
  return str.replace(new RegExp(/[-_]+/, 'g'), ' ').replace(new RegExp(/[^\w\s]/, 'g'), '').replace(new RegExp(/\s+(.)(\w+)/, 'g'), function ($1, $2, $3) {
    return "".concat($2.toUpperCase() + $3.toLowerCase());
  }).replace(new RegExp(/\s/, 'g'), '').replace(new RegExp(/\w/), function (s) {
    return s.toUpperCase();
  });
};
export { isAString, isValueInString, lowerCaseAllButFirst, lowerTrimString, stringHasAllValues, stringHasAttr, stringHasClass, stringHasId, toCamelCase, toKebabCase, toPascalCase, upperCaseFirst };